export default "__VITE_ASSET__D7lG3IsK__"